import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

const DEFAULT_HOURS = { enabled: false, start: "09:00", end: "17:00" };

export default function WorkHoursEditor({ value = {}, onChange }) {
  const hours = DAYS.reduce((acc, day) => {
    acc[day] = value[day] || { ...DEFAULT_HOURS };
    return acc;
  }, {});

  const setDay = (day, field, val) => {
    onChange({ ...hours, [day]: { ...hours[day], [field]: val } });
  };

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Work Hours</Label>
      <div className="rounded-lg border divide-y text-sm">
        {DAYS.map((day) => {
          const d = hours[day];
          return (
            <div key={day} className="flex items-center gap-3 px-3 py-2">
              <Switch
                checked={d.enabled}
                onCheckedChange={(v) => setDay(day, "enabled", v)}
              />
              <span className="w-20 capitalize text-sm font-medium">{day}</span>
              {d.enabled ? (
                <div className="flex items-center gap-2 flex-1">
                  <Input
                    type="time"
                    value={d.start}
                    onChange={(e) => setDay(day, "start", e.target.value)}
                    className="h-7 text-xs w-28"
                  />
                  <span className="text-muted-foreground">–</span>
                  <Input
                    type="time"
                    value={d.end}
                    onChange={(e) => setDay(day, "end", e.target.value)}
                    className="h-7 text-xs w-28"
                  />
                </div>
              ) : (
                <span className="text-muted-foreground text-xs">Day off</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}